<template>
  <div>

    <table class="final-table full-width th-no-padding lines-b">
      <colgroup ref="colgroup1">
        <col width="10px">
        <col width="10px">
      </colgroup>
      <tr>
        <c-table-header
        title="Name"
        code="name"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
        <c-table-header
        title="Value"
        code="value"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
      </tr>
      <tr>
        <td class="sticky">
          <v-text-field
          v-model="filters.search.name"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo></v-text-field>
        </td>
        <td>
        </td>
      </tr>
      <draggable 
      :list="itemView"
      :element="'tbody'"
      :options="{animation: 150, handle: '.drag-handle'}"
      @change="dragChange">
        <list-row 
        v-for="item in itemView"
        :key="item.tempID + 'a' + item.ordering" 
        :item="item"
        :searchFilters="filters.search"
        :selected="selected"
        @checkRow="checkRow(item)"
        @click.native="clickRow(item)">
        </list-row>
      </draggable>

    </table>

    <!-- PAGINATION -->
    <c-pagination
    :page="page"
    :pagination="pagination"
    :filters="filters"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage"
    ></c-pagination>
    <!-- PAGINATION -->

  </div>
</template>

<script>
import ListController from '@/mixins/NewListController'
import ServerListBindings from '@/mixins/ServerListBindings'

import ListRow from './setting-row'
import Draggable from 'vuedraggable'
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: {
    
  },
  mixins: [ListController, ServerListBindings],
  components: {
    ListRow,
    Draggable,
    JsonViewer
  },
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 10,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          name: '',
          value: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      ordering: 'ordering'
    }
  },
  methods: {
    loadAPI () {
      console.log('loadAPI')

      // Filter function
      var items = this.items
      if (this.filters.search.name) {
        var keywords = (this.filters.search.name || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }

      // Sort function
      items = items.sort((a, b) => this.filters.sortAscending ? a.ordering - b.ordering : b.ordering - a.ordering)
      /* if (this.filters.sortCol === 'name') {
        items = items.sort((a, b) => this.filters.sortAscending ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)) 
      } */

      this.pagination.rowCount = items.length
      this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
      if (this.items.length > items.length) {
        this.currentIndex = 0
      }

      // paginate
      var index = (this.page) * this.filters.rowsPerPage
      items = items.slice(index, index + this.filters.rowsPerPage)

      this.itemView = items

    },
    fetchAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/settings`)
          .then(response => {
            var hrend = response.data.execution_time
    
            var rows = response.data.rows
            this.items = rows
            this.generateIdsAndOrdering()
            this.loadAPI()
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.fetchAPI()
  }
}
</script>